if (typeof ShippingAvailablity !== "function") {
  class ShippingAvailablity extends HTMLElement {
    constructor() {
      super();

      // Create shipping indicator element
      const shippingIndicator = document.createElement("div");
      shippingIndicator.classList.add("alert");
      shippingIndicator.classList.add("alert--note");
      shippingIndicator.classList.add("alert--circle");
      shippingIndicator.style.marginBottom = "0px"; // Set the bottom margin to 0px
      shippingIndicator.innerHTML =
        "Select State to check shipping availability";

      // Append the shippingIndicator to the custom element
      this.appendChild(shippingIndicator);

      // Define the function to handle changes in the selected state
      const handleStateChange = () => {
        const selectedState = localStorage.getItem("selected-state");
        if (selectedState) {
          // Do something with selectedState if needed
          shippingIndicator.classList.add("alert--success");
          shippingIndicator.classList.remove("alert--note");
          shippingIndicator.innerHTML = "Shipping available to " + selectedState;
        } else {
          // Handle the case when selectedState is not set
          shippingIndicator.classList.add("alert--circle-loading");
        }
      };

      // Add an "change" event listener to each select element
      handleStateChange();

      // Add an event listener to ensure the DOM is fully loaded before running your code
      document.addEventListener("DOMContentLoaded", () => {
        // Query for the state selectors after the DOM is fully loaded
        const stateSelectors = document.querySelectorAll('[data-key="state-selector"]');
        stateSelectors.forEach((selectElement) => {
          selectElement.addEventListener("change", () => {
            const selectedState = selectElement.value;
            localStorage.setItem("selected-state", selectedState);
            handleStateChange();
          });
        });
      });
    }
  }

  if (typeof customElements.get("shipping-availability") === "undefined") {
    customElements.define("shipping-availability", ShippingAvailablity);
  }
}
